import { Component, Inject, OnInit, Optional } from '@angular/core';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { Item } from '@app/core/components/listbox/listbox.component';
import { SrCheckListExpensesGet, SrChecklistService } from '@app/services/sr-checklist.service';

@Component({
    selector: 'tt-sr-check-list-expenses',
    templateUrl: './sr-check-list-expenses.component.html',
    styleUrls: ['./sr-check-list-expenses.component.css'],
    standalone: false,
})
export class SrCheckListExpensesComponent implements OnInit {
    public page?: SrCheckListExpensesGet;
    public expenses: Item[] = [];

    constructor(
        private readonly checklist: SrChecklistService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) { this.navigator = useNavigatorFor(navigator, this); }

    public async ngOnInit(): Promise<void> {
        const params = { checklistdata_keyno: String(this.navigator?.params['checklistdata_keyno'] ?? '') };
        const [page, expenses] = await Promise.all([this.checklist.getExpenses(params), this.checklist.getExpenseList(params)]);
        this.page = page;
        this.expenses = expenses;
    }
}
